// Constantes de endereço: mapeamento de nomes de campos e configuração dos
// campos de telefone para os tipos residencial e comercial. Centralizado
// aqui para evitar duplicação e erros de digitação nos formulários.

export const FIELD_NAMES = {
  residencial: {
    cep: 'cepResidencial',
    logradouro: 'logradouroResidencial',
    numero: 'numeroResidencial',
    complemento: 'complementoResidencial',
    bairro: 'bairroResidencial',
    estado: 'estadoResidencial',
    municipio: 'municipioResidencial',
    pais: 'paisResidencial',
    email: 'emailResidencial',
    correspondencia: 'correspondenciaResidencial'
  },

  // Comercial tem dois campos de telefone (fixo e celular)
  comercial: {
    cep: 'cepComercial',
    logradouro: 'logradouroComercial',
    numero: 'numeroComercial',
    complemento: 'complementoComercial',
    bairro: 'bairroComercial',
    estado: 'estadoComercial',
    municipio: 'municipioComercial',
    pais: 'paisComercial',
    email: 'emailComercial',
    telefone: 'telefoneComercial',
    telefone2: 'telefone2Comercial',
    correspondencia: 'correspondenciaComercial'
  }
};

export const PHONE_FIELDS = {
  // Residencial: usa nomes diretos (não passa por FIELD_NAMES); celular é obrigatório
  residencial: [
    {
      name: 'telefoneCelular',
      label: 'Celular',
      required: true,
      placeholder: '(67) 99999-9999'
    },
    {
      name: 'telefoneResidencial',
      label: 'Telefone Fixo',
      required: false,
      placeholder: '(67) 3333-3333'
    }
  ],

  // Comercial: nomes combinados com FIELD_NAMES (names.telefone); ambos opcionais
  comercial: [
    {
      name: 'telefone',
      label: 'Telefone Comercial',
      required: false,
      placeholder: '(67) 3333-3333'
    },
    {
      name: 'telefone2',
      label: 'Celular Comercial',
      required: false,
      placeholder: '(67) 99999-9999'
    }
  ]
};
